import axios from "../axios";

export const warehouseStockApi = {
  getStock: async (params = {}) => {
    return axios
      .get(`/inventory/warehouse_stock`, { params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching warehouse stock:", error);
        return { error: true, data: [] };
      });
  },

  getProductStock: async (productId, params = {}) => {
    return axios
      .get(`/inventory/warehouse_stock/products/${productId}`, { params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching product stock:", error);
        return { error: true, data: null };
      });
  },

  getProductStockReport: async (productId, params = {}) => {
    return axios
      .get(`/inventory/warehouse_stock/products/${productId}/report`, { params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching product stock report:", error);
        return { error: true, data: [] };
      });
  },
};


